import { IApplicationState } from '../../types/redux';
import { TUserAnalytics } from '../../types/currentUser';

export const getUserForAnalytics = (state: IApplicationState): TUserAnalytics => {
  const { user } = state;

  if (user) {
    return {
      type: state.lkType,
      email: user.email || '',
      cianUserId: user.cianUserId,
      userId: user.realtyUserId,
    };
  }

  return {
    type: 'not_authorized',
  };
};
